import { Component, OnInit } from '@angular/core';
import { BaseModalDirective } from '../base-modal';

@Component({
    selector: 'nh-doc-upload-faqs',
    templateUrl: './doc-upload-faqs.component.html',
    styleUrls: ['./doc-upload-faqs.component.scss'],
    standalone: false
})
export class DocUploadFaqsComponent extends BaseModalDirective implements OnInit {
  statuses: { title: string; description: string; expanded?: boolean }[] = [
    { title: "DOCUPLOAD_FAQ_HEADER_01", description: "DOCUPLOAD_FAQ_DESCRIPTION_01" },
    { title: "DOCUPLOAD_FAQ_HEADER_02", description: "DOCUPLOAD_FAQ_DESCRIPTION_02" },
    { title: "DOCUPLOAD_FAQ_HEADER_03", description: "DOCUPLOAD_FAQ_DESCRIPTION_03" },
    { title: "DOCUPLOAD_FAQ_HEADER_04", description: "DOCUPLOAD_FAQ_DESCRIPTION_04" }
  ]
  viewOnlyTCCStatuses: { title: string; description: string; expanded?: boolean }[] = [
    { title: "DOCUPLOAD_FAQ_HEADER_03", description: "DOCUPLOAD_FAQ_DESCRIPTION_03" },
    { title: "DOCUPLOAD_FAQ_HEADER_04", description: "DOCUPLOAD_FAQ_DESCRIPTION_04" }
  ]
  viewOnlyTCC: boolean = false;

  ngOnInit() {
    this.viewOnlyTCC = sessionStorage.getItem('ReadTCC') === 'true' ? true : false;
  }

  get currentStatus() {
    return this.viewOnlyTCC ? this.viewOnlyTCCStatuses : this.statuses;
  }
}
